/**
 * EnergyConnect.WebApi | v1
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export const PipelineType = {
    NotSpecified: 'NotSpecified',
    Request: 'Request',
    Response: 'Response',
    Notify: 'Notify',
    ToDo: 'ToDo',
    ToDoHandled: 'ToDoHandled',
} as const;
export type PipelineType = typeof PipelineType[keyof typeof PipelineType];

